import { Dialog } from "@blueprintjs/core"
import styled from "@emotion/styled"

export const SingleAddModalStyled = styled(Dialog)({
  width: "600px",
  height: "50vh",
  maxHeight: "800px",
})
